export const getSequenceFormatPreview = ({ digitCount, seed }) => {
  const seedNumber = Number.parseInt(seed, 10);

  if (Number.isNaN(seedNumber)) {
    return '';
  }

  const widthNumber = Number.parseInt(digitCount, 10);
  const width = Number.isNaN(widthNumber) || widthNumber < 1 ? 0 : widthNumber;

  return String(seedNumber).padStart(width, '0');
};
